import React from 'react';

const OverviewTableUnNumberDangerCell = ({ rowValue }) => {
  if (rowValue !== 'null') {
    let unNumDangerCode = rowValue.split('|');
    if (unNumDangerCode[0] && unNumDangerCode[1]) {
      return (
        <>
          <div className="dangerCode">{unNumDangerCode[1]}</div>
          <div className="unNumber">{unNumDangerCode[0]}</div>
        </>
      );
    } else {
      return '';
    }
  } else {
    return '';
  }
};

export default OverviewTableUnNumberDangerCell;
